import React from "react";
import "../components/styles/Loading.css";

export default function Loading() {
  return (
    <div id="loading-page">
      <div id="loading-container">
        <div className="ring"></div>
        <div className="ring"></div>
        <div className="ring"></div>
        <div className="ring"></div>
        <h3 className="loading-text">Cargando</h3>
      </div>
    </div>
  );
}
